import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BookingSummary.html?raw';
import { TiEntities } from "./TiTypes";
import TiTransportGoodManager from './TransportGoodsManager';
import "./TransportGoodsManager";


class TiBookingSummary extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private summary1: HTMLElement;
    private summary2: HTMLElement;
    private summary3: HTMLElement;
    private summary4: HTMLElement;
    private sectionsContainer: HTMLElement;
    private headingRoute: HTMLElement;
    private orderNo: HTMLElement;
    //private transportGoodView: TiTransportGoodView;
    private transportGoodsContainer: HTMLElement;
    private sectionTransportGoods: HTMLElement;
    private sectionOrderNo: HTMLElement;
    private sectionWarnings: HTMLElement;
    private warningsContainer: HTMLElement;
    private sectionStatus: HTMLElement;
    private status: HTMLElement;
    private sectionBookerInfo: HTMLElement;
    private bookerInfo: HTMLElement;

    //private transportGoodsManager: TiTransportGoodManager;

    private data: TiEntities.BookingEntityData;


    setData(data: TiEntities.BookingEntityData) {
        this.data = data;

        
        this.UiModder.domAttr.set(this.summary1, "innerHTML", this.stringFormat("{0}<br>{1}", data.division, data.terminal));
        this.UiModder.domClass.toggle(this.summary1.parentElement, "w3-hide", !this.data.division || !this.data.terminal);

        this.UiModder.domAttr.set(this.summary2, "innerHTML", data.logisticResourceTXT);
        this.UiModder.domClass.toggle(this.summary2.parentElement, "w3-hide", !this.data.logisticResourceTXT );


        this.UiModder.domAttr.set(this.summary3, "innerHTML", data.route);
        this.UiModder.domClass.toggle(this.summary3.parentElement, "w3-hide", !this.data.route );

        this.UiModder.domAttr.set(this.summary4, "innerHTML", data.offloading);
        this.UiModder.domClass.toggle(this.summary4.parentElement, "w3-hide", !this.data.offloading);


        this.UiModder.domAttr.set(this.orderNo, "innerHTML", data.orderNo);
        this.UiModder.domClass.toggle(this.sectionOrderNo, "w3-hide", typeof (data.orderNo) != "string");

        this.UiModder.domConstruct.empty(this.transportGoodsContainer);
        this.hideNode(this.sectionTransportGoods);

        //this.transportGoodsManager.reset();
        if (data.transportGoods?.length) {
            //this.hideNode(this.sectionTransportGoods, false);

            let tgManager = new TiTransportGoodManager();
            tgManager.placeAt(this.transportGoodsContainer, "only");
            
            
            for (let tg of data.transportGoods) {
            //    this.UiModder.domConstruct.create("p", {
            //        innerHTML: tg.order_number

                //    }, this.transportGoodsContainer);
                tgManager.addTransportGood(tg);
            }
        }
        if (data.transportGood) {
            
        }

        this.hideNode(this.orderNo, !data.orderNo);
        this.orderNo.innerHTML = data.orderNo;
        
        
        //this.hideNode(this.transportGoodView, !data.transportGood);

        this.UiModder.domAttr.set(this.status, "innerHTML", data.status);
        this.UiModder.domClass.toggle(this.sectionStatus, "w3-hide", typeof (data.status) != "string");

        if (data.is_rebooking_available ) {
            this.UiModder.domConstruct.create("i", { "className": "fas fa-exclamation-triangle w3-text-orange", "innerHTML": "&nbsp;" }, this.headingRoute, "first");
        }

        this.UiModder.domAttr.set(this.bookerInfo, "innerHTML",
            this.stringFormat(this.translations["TiBooking__BookerInfo_Formatstring"], data.bookerName, this.dateTimeToString(new Date(data.bookingDate), "dd.MM.yyyy HH:mm"))
        );
        this.UiModder.domClass.toggle(this.sectionBookerInfo, "w3-hide", !data.bookerName || !data.bookingDate)


        this.hideNode(this.sectionWarnings);
        this.UiModder.domConstruct.empty(this.warningsContainer);

        if (data.warnings) {
            
            this.emit("warning");
            this.hideNode(this.sectionWarnings, (data.warnings?.length) ==  0);

            for (let warning of data.warnings) {
                this.UiModder.domConstruct.create("div", { "innerHTML": warning, "className": "warning" }, this.warningsContainer);
            }
        }

    }

   
    makeCompact(bCompact: boolean = true) {
        this.UiModder.domClass.toggle(this.sectionsContainer, "flex_row", bCompact !== false);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.handleAs = "jsonWithDate";

    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(TiBookingSummary);